// extracted by mini-css-extract-plugin
module.exports = {"featured-offers":"featured-offers_featured-offers__LXyCd","featured-offers__container":"featured-offers_featured-offers__container__I6ot8"};